const BackendUrl = {
    production: '/ratency',
    development: process.env.REACT_APP_API_URL || '/ratency'
};
export default BackendUrl;
